import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, catchError, tap, throwError } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private loginApiUrl = `${environment.authUrl}/auth/login`;
  private isAuthenticated = new BehaviorSubject<boolean>(false);
  private token: string | null = null;
  private isHandlingInvalidToken = false;

  CURRENT_LOGGED_USER: any;
  constructor(
    private http: HttpClient,
    private router: Router,
    private toastr: ToastrService
  ) {}
  publicRoutes: string[] = ['confirm-email-update'];

  login(email: string, password: string): Observable<any> {
    return this.http.post(this.loginApiUrl, { email, password }).pipe(
      tap((response: any) => {
        if (response.accessToken) {
          sessionStorage.setItem('AUTH_TOKEN', response.accessToken);
          this.isAuthenticated.next(true);
        }
      }),
      catchError((error) => {
        let errorMessage = 'An unknown error occurred';
        if (error.message) {
          errorMessage = error.message;
        }
        return throwError(() => new Error(errorMessage));
      })
    );
  }

  logoutFn() {
    this.router.navigate(['/login']);
    sessionStorage.removeItem('AUTH_TOKEN');
    sessionStorage.removeItem('roleID');
    sessionStorage.removeItem('permissions');

    sessionStorage.removeItem('AUTH_TOKEN');
    sessionStorage.removeItem('roleID');

    sessionStorage.removeItem('userName');
    sessionStorage.removeItem('userRole');

    this.isAuthenticated.next(false);
  }

  logout() {
    this.toastr.success('You have been logged out', 'Session Ended');
    this.logoutFn();
  }

  isLoggedIn(): Observable<boolean> {
    return this.isAuthenticated.asObservable();
  }

  setToken(token: string) {
    this.token = token;
  }

  getToken(): string | null {
    return this.token;
  }

  isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Math.floor(Date.now() / 1000);
      return payload.exp < currentTime;
    } catch (error) {
      return true; // Treat token as expired if decoding fails
    }
  }

  handleInvalidToken() {
    sessionStorage.clear();
    sessionStorage.clear();

    const currRoute = this.router.url; // gets the full URL path as a string

    const isPublicRoute = this.publicRoutes.some((publicRoute) =>
      currRoute.includes(publicRoute)
    );

    if (!isPublicRoute) {
      this.toastr.warning('Your session has expired. Please log in again.');
      this.router.navigate(['/login']);
    }
  }

  getSelectedBranchId(): any {
    const branchID = sessionStorage.getItem('selectedBranchId');
    return branchID;
  }

  getUserProfile(): Observable<any> {
    return this.http.get(`${environment.authUrl}/profile`);
  }

  loadUserProfile() {
    const authToken = sessionStorage.getItem('AUTH_TOKEN');
    if(!authToken){
      return;
    }
    this.getUserProfile().subscribe({
      next: (res) => {
        this.CURRENT_LOGGED_USER = res.data.admin;
      },
      error: (err) => {
        console.error('error:', err);
      },
    });
  }
}
